import { OrgAvatar, StatusChip, isolate, layout } from '@batiflow/ui';
import { LockClosed16Regular } from '@fluentui/react-icons';
import { __css, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useLocale } from '@/app/providers/i18n-provider';
import { AppLink } from '@/shared/components/app-link';
import { accessParts, isClosed, type MySpace } from './model';

const useStyles = __css({"link":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","i8kkvl":"f1xcgk68","Dbcxam":0,"rjzwhg":0,"Bblux5w":"fnllxr2","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f12n3xlw","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"ft85np5","qttt6h":"fsmx9qy","sj55zd":"f19n0e5","De3pzq":"fxugw4r","Bi91k9c":"feu1g3u","Jwef8y":"f1knas48","Bde5pd6":"fbnuktb"},"body":{"Bh6795r":"fqerorx","Bgto7am":"fuzgk9b","mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1j0q4x9"},"name":{"Bhrd7zp":"fl43uef","Btd35i7":"fjksvth"},"meta":{"mc9l5x":"f22iagw","Eh141a":"fni485r","i8kkvl":"fsnqrgy","Be2twd7":"fy9rknc","sj55zd":"fkfq4zb"},"chips":{"mc9l5x":"f22iagw","Bnnss6s":"fi64zpg","i8kkvl":"fsnqrgy"}});

/**
 * One shared space of the list: the host organisation's avatar, the name, the kind and who hosts
 * it; for an external space also how the person got in (way, rights, end date). The whole row is
 * the link that opens the space.
 */
export function SpaceRow({ space }: { space: MySpace }) {
  const { t } = useTranslation('spaces');
  const styles = useStyles();
  const locale = useLocale();
  const { host } = space;
  return (
    <li>
      <AppLink to="/s/$spaceId" params={{ spaceId: space.id }} className={styles.link}>
        <OrgAvatar
          name={host.name}
          size={32}
          decorative
          {...(host.logoUrl ? { logoUrl: host.logoUrl } : {})}
        />
        <span className={styles.body}>
          <bdi className={styles.name}>{space.name}</bdi>
          <span className={styles.meta}>
            <span>{t(`kinds.${space.kind}`)}</span>
            <span aria-hidden="true">·</span>
            <span>{t('page.hostedBy', { host: isolate(host.name) })}</span>
          </span>
          {space.external ? (
            <span className={styles.meta}>
              {accessParts(
                { via: space.via, rights: space.rights, expiresAt: space.expiresAt },
                t,
                locale,
              ).map((part, index) => (
                <span key={part}>
                  {index > 0 ? <span aria-hidden="true">· </span> : null}
                  {part}
                </span>
              ))}
            </span>
          ) : null}
        </span>
        <span className={styles.chips}>
          {space.external ? <StatusChip label={t('list.external')} intent="informative" /> : null}
          {isClosed(space) ? (
            <StatusChip
              label={t('status.closed')}
              intent="warning"
              icon={<LockClosed16Regular />}
            />
          ) : null}
        </span>
      </AppLink>
    </li>
  );
}


import "/opt/batiflow/app/apps/web/src/features/spaces/space-row.griffel.css";